import {
  Autocomplete,
  CircularProgress,
  FormControl,
  FormGroup,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { JiraAvailableProject } from "../../../../app/backendTypes";

function JiraAvailableProjectPicker(props: {
  projects: JiraAvailableProject[];
  loading: boolean;
  error: string | undefined;
  onChange: (val: JiraAvailableProject | null) => void;
  initialValue: JiraAvailableProject | null;
}) {
  const { projects, loading, error, onChange, initialValue } = props;

  const theme = useTheme();

  return (
    <FormControl fullWidth>
      <FormGroup>
        <Autocomplete
          value={initialValue}
          isOptionEqualToValue={(o, v) => o.id === v.id}
          size="small"
          disabled={loading || Boolean(error)}
          options={projects}
          getOptionLabel={(project) => `${project.name} (${project.id})`}
          renderOption={(props, project) => (
            <Typography {...props}>{project.name}</Typography>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
              placeholder={
                loading ? "Loading..." : error ? "Error" : "Pick a project"
              }
              error={Boolean(error)}
              sx={{
                input: {
                  "&::placeholder": {
                    color: Boolean(error)
                      ? theme.palette.error.main
                      : "text.secondary",
                    opacity: 1,
                  },
                },
              }}
            />
          )}
          onChange={(_, value) => onChange(value)}
        />
      </FormGroup>
    </FormControl>
  );
}

export default JiraAvailableProjectPicker;
